/*
 *
 * GiftCardProduct actions
 *
 */
import * as reqHandler from '../../config/services/serviceHandler';
import endpoint from '../../config/endPoints';
import { rootApiResponse, clearDefaultError } from '../HeaderContainer/actions';
import { utils, constants } from '../../devUtils';
import {
  DEFAULT_ACTION,
  FETCH_GIFTCARDDETAILS_SUCCESS,
  SET_GIFTCARD_CONTACT,
} from './constants';

export const defaultAction = (payload = false) => ({ type: DEFAULT_ACTION, payload });

const successFetchGiftCardDetailsAction = (payload) => ({ type: FETCH_GIFTCARDDETAILS_SUCCESS, payload });
const setProductContactUs = (payload) => ({ type: SET_GIFTCARD_CONTACT, payload });

export const fetchGiftCardDetails = (payload) => async (dispatch, getState, api) => {
  dispatch(defaultAction());
  try {
    const authPrerequist = utils.getAuthPrerequist(getState, true);
    const constUrl = `${endpoint.GET_GIFTCARD_DETAILS}/${payload.productName}`;
    const giftCard_data = await reqHandler.getHandler(api, constUrl, payload, authPrerequist);
    dispatch(successFetchGiftCardDetailsAction(giftCard_data));
  } catch (err) {
    // dispatch(rootApiResponse({ api: 'FETCH_Resturant', reason: err, success: false }));
  }
};

const SetProductContactUs = (payload) => async (dispatch, getState, api) => {
  dispatch(defaultAction(true));
  dispatch(clearDefaultError());
  try {
    const form_data = {
      'entry.1852619585': payload.name,
      'entry.340311596': payload.email,
      'entry.997072234': payload.mobile,
      'entry.296470103': payload.company,
      'entry.1529036057': payload.product_name,
      'entry.1806331036': payload.quantity,
    };
    const giftCard_data = await reqHandler.postHandler(api, endpoint.POST_PRODUCT_CONTACT_US, form_data);
    dispatch(setProductContactUs({ response: giftCard_data, status: true, timestamp: new Date() }));
    dispatch(rootApiResponse(utils.successResponse(DEFAULT_ACTION, constants.ALERT_CONTACT_SAVED.SUCCESS)));
  } catch (err) {
    dispatch(rootApiResponse(utils.errorResponse(DEFAULT_ACTION, constants.ALERT_CONTACT_SAVED.FAILURE)));
  }
};
export { successFetchGiftCardDetailsAction, SetProductContactUs };



// WEBPACK FOOTER //
// client/containers/GiftCardProduct/actions.js